var config = require("Config");

export async function verifyActivationCode(token) {
    return new Promise((resolve, reject) => {

        if (!token || token.length <= 0) {
            reject("Invalid Activation Code");
            return;
        }

        fetch(`${config.discoveryServiceUrl}/api/v1/invitations/${token}/info`).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error("Invalid Activation Code");
        }).then((result) => {
            resolve(result);
        }).catch((error) => {
            console.log(error);
            sessionStorage.removeItem("redirectUrl");
            sessionStorage.removeItem("activationToken");
            reject("Invalid Activation Code");
        });
    });
}